import React from 'react';
import { Link } from 'react-router-dom';
import { useSlider, useScrollY } from '../hooks/useAnimations';
import IMG from '../data/images';
import logo from '../assets/images/logo.webp';

const slides = [
  { img: IMG.hero1, title: <>Where Every Child's <br/><span style={{color:'var(--gold)'}}>Journey Begins</span> with Joy</>, sub: "Finland's world-class early education philosophy, brought to life for your child." },
  { img: IMG.hero2, title: <>Learning Through <br/><span style={{color:'var(--gold)'}}>Play</span>, Growing with Purpose</>, sub: "No homework. No pressure. Just joyful growth at every child's natural pace." },
  { img: IMG.hero3, title: <><span style={{color:'var(--gold)'}}>Inspired</span> by Finland <br/>Built for the World</>, sub: "The world's #1 education philosophy — now in your neighbourhood." },
];

const HeroSlider = () => {
  const { index, next, prev, goTo } = useSlider(slides.length, 5000);
  const scrollY = useScrollY();

  return (
    <section style={{ height: '100vh', position: 'relative', overflow: 'hidden' }}>
      {/* Slides */}
      {slides.map((s, i) => (
        <div key={i} style={{
          position: 'absolute', inset: 0,
          opacity: i === index ? 1 : 0,
          transition: 'opacity 1s ease-in-out',
          zIndex: i === index ? 1 : 0,
        }}>
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${s.img})`,
            backgroundSize: 'cover', backgroundPosition: 'center',
            transform: `translateY(${scrollY * 0.3}px) scale(1.1)`,
            transition: 'transform 0.1s linear',
          }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(10,20,40,0.7) 0%, rgba(10,20,40,0.85) 100%)' }} />
        </div>
      ))}

      {/* Content */}
      <div style={{
        position: 'relative', zIndex: 10, height: '100%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{ textAlign: 'center', maxWidth: 800, padding: '0 24px' }}>
          <img src={logo} alt="Finland Early Years" style={{
            height: 110, margin: '0 auto 18px',
            filter: 'drop-shadow(0 4px 24px rgba(232,168,56,0.3))',
            animation: 'float 4s ease-in-out infinite',
          }} />
          <div style={{ color: 'var(--gold)', fontSize: '0.78rem', fontWeight: 700, letterSpacing: '4px', textTransform: 'uppercase', marginBottom: 18 }}>
            Inspired by Finland · Built for the World
          </div>
          <h1 key={index} style={{
            fontFamily: 'var(--fh)', fontSize: '3.2rem', fontWeight: 800,
            color: 'var(--white)', lineHeight: 1.15, marginBottom: 20,
            animation: 'fadeUp 0.8s ease-out',
          }}>
            {slides[index].title}
          </h1>
          <p key={`sub-${index}`} style={{
            color: 'rgba(255,255,255,0.7)', fontSize: '1.08rem', lineHeight: 1.8,
            maxWidth: 560, margin: '0 auto 36px',
            animation: 'fadeUp 0.8s ease-out 0.15s both',
          }}>
            {slides[index].sub}
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', animation: 'fadeUp 0.8s ease-out 0.3s both' }}>
            <Link to="/admissions" className="btn btn-gold">Book a Campus Visit</Link>
            <Link to="/programmes" className="btn btn-outline">Explore Programmes</Link>
          </div>
        </div>
      </div>

      {/* Arrows */}
      <button onClick={prev} style={{ position:'absolute', left:20, top:'50%', transform:'translateY(-50%)', zIndex:20, background:'rgba(255,255,255,0.15)', border:'none', borderRadius:'50%', width:48, height:48, color:'#fff', fontSize:'1.2rem', cursor:'pointer', backdropFilter:'blur(8px)', transition:'background 0.3s' }}
        onMouseEnter={e => e.target.style.background='rgba(232,168,56,0.5)'}
        onMouseLeave={e => e.target.style.background='rgba(255,255,255,0.15)'}
      >‹</button>
      <button onClick={next} style={{ position:'absolute', right:20, top:'50%', transform:'translateY(-50%)', zIndex:20, background:'rgba(255,255,255,0.15)', border:'none', borderRadius:'50%', width:48, height:48, color:'#fff', fontSize:'1.2rem', cursor:'pointer', backdropFilter:'blur(8px)', transition:'background 0.3s' }}
        onMouseEnter={e => e.target.style.background='rgba(232,168,56,0.5)'}
        onMouseLeave={e => e.target.style.background='rgba(255,255,255,0.15)'}
      >›</button>

      {/* Dots */}
      <div style={{ position: 'absolute', bottom: 32, left: '50%', transform: 'translateX(-50%)', zIndex: 20, display: 'flex', gap: 10 }}>
        {slides.map((_, i) => (
          <button key={i} onClick={() => goTo(i)} style={{
            width: i === index ? 36 : 12, height: 12, borderRadius: 6,
            background: i === index ? 'var(--gold)' : 'rgba(255,255,255,0.3)',
            border: 'none', cursor: 'pointer', transition: 'all 0.4s',
          }} />
        ))}
      </div>

      {/* Scroll indicator */}
      <div style={{ position: 'absolute', bottom: 80, left: '50%', transform: 'translateX(-50%)', zIndex: 20, animation: 'float 2s ease-in-out infinite' }}>
        <div style={{ width: 24, height: 38, border: '2px solid rgba(255,255,255,0.3)', borderRadius: 12, display: 'flex', justifyContent: 'center', paddingTop: 6 }}>
          <div style={{ width: 3, height: 8, background: 'var(--gold)', borderRadius: 2 }} />
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          h1 { font-size: 2.2rem !important; }
          .btn { padding: 12px 24px !important; font-size: 0.8rem !important; }
        }
      `}</style>
    </section>
  );
};

export default HeroSlider;
